export default {
	namespaced: true,
	state: {
		item: [],
		subtotal: 0,
		success: null
	},
	mutations: {
		add(state, payload) {
			let has = false;
			state.item.forEach((row, key) => {
				if(row.cd_pedido == payload.cd_pedido){
					has = true;
				}
			})
			if(!has) {
				state.item.push(payload);
				state.subtotal += parseFloat(payload.valor);
				setCookie(state.item);
				state.success = true
			} else {
				state.success = false
			}
			
	    	
	    },
	    set(state, payload) {
	    	state.subtotal = 0;
	    	state.item = payload;
	    	state.item.forEach(function(row) {
	    		state.subtotal += parseFloat(row.valor);
	    	});
	    },
	    clear(state) {
	    	setCookie([]);
	    	state.item = [];
	    	state.subtotal = 0;
	    },
	    remove(state, payload) {
	    	state.item.forEach((row, key) => {
				if(row.cd_pedido == payload){
					state.item.splice(key, 1);
					state.subtotal -= parseFloat(row.valor)
				}
			})
			setCookie(state.item);
	    },
	},
}

function setCookie(item) {
	let strcart = JSON.stringify(item);
    $cookies.set('b_cart', btoa(strcart));
}
